(function () {
  const KEY = "qlex_theme";

  function getStored() {
    const v = localStorage.getItem(KEY);
    return v === "dark" || v === "light" ? v : "light";
  }

  function applyTheme(mode) {
    if (mode !== "dark" && mode !== "light") return;
    document.documentElement.setAttribute("data-theme", mode);
    localStorage.setItem(KEY, mode);
    syncToggles();
  }

  function cycleTheme(e) {
    if (e) e.stopPropagation();
    applyTheme(getStored() === "dark" ? "light" : "dark");
  }

  function syncToggles() {
    const isDark = getStored() === "dark";
    document.querySelectorAll("[data-theme-toggle]").forEach((btn) => {
      btn.setAttribute("aria-pressed", isDark ? "true" : "false");
      btn.setAttribute(
        "aria-label",
        isDark ? "Switch to light mode" : "Switch to dark mode"
      );
    });
  }

  function onReady() {
    applyTheme(getStored());
    document.querySelectorAll("[data-theme-toggle]").forEach((btn) => {
      btn.addEventListener("click", cycleTheme);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  window.qlexTheme = { set: applyTheme, get: getStored, cycle: cycleTheme };
})();
